// Bilingual EN/CS strings for the FPL Timing Analyzer.
export const STRINGS = {
    en: {
        pageTitle: "FPL Timing Analyzer",
        pageSubtitle: "Historical player performance, consistency and timing signals across the last 6 Premier League seasons (2020-21 → 2025-26).",
        loading: "Loading…",
        noData: "No data yet — try adjusting the filters.",
        tabExplorer: "Player Explorer",
        tabCompare: "Compare",
        tabFinders: "Finders",
        tabPool: "Team Season DNA",
        tabMatrix: "Fixture Matrix",
        tabSimulator: "Season Simulator",
        tabTransfers: "Transfers",
        tabHauls: "Hauls",
        tabFdrPerf: "FDR Performance",
        findersFdrAbility: "Vs opponent strength",
        fdrAbilityExplain: "PPG against opponents by difficulty (FDR from current team strength; whole history 2016-2026). Delta shows how much better/worse vs the player's overall average.",
        allPositions: "All positions",
        position: "Position",
        seasons: "Seasons",
        season: "Season",
        totalPoints: "Total points",
        gamesPlayed: "Games played",
        consistency: "Consistency",
        explosiveness: "Explosiveness",
        value: "Value",
        avg: "Avg",
        ppg: "PPG",
        gw: "GW",
        consistencyExplain: "Reward for both high floor and low variance — combines PPG with variance.",
        explosivenessExplain: "% of played GWs with ≥10 points.",
        valueExplain: "Total points ÷ average price (£m).",
        valueNewExplain: "Last season's points ÷ NEW 2026/27 price — who gives the most points per £m at today's price.",
        searchPlaceholder: "Search a player — Salah, Haaland, Palmer…",
        pickPlayer: "Pick a player to explore",
        pointsCurve: "Points per gameweek",
        selectedSeason: "Selected season",
        averageCurve: "5-season average",
        timingBreakdown: "Season-phase breakdown",
        periodGw1_6: "Start (GW1-6)",
        periodGw7_12: "Early build (GW7-12)",
        periodGw13_18: "Pre-Christmas (GW13-18)",
        periodGw19_24: "Festive (GW19-24)",
        periodGw25_30: "Pre run-in (GW25-30)",
        periodGw31_38: "Run-in (GW31-38)",
        compareIntro: "Pick 2-4 players to compare seasonal profiles side-by-side.",
        addPlayer: "Add player",
        remove: "Remove",
        findersConsistent: "Most consistent",
        findersExplosive: "Most explosive",
        findersValue: "Best value",
        findersValueNew: "Value 26/27",
        findersPeriod: "Best per period",
        period: "Period",
        topN: "Top N",
        minSeasons: "Min seasons",
        sortStrongest: "Strongest",
        sortWeakest: "Weakest",
        metricPpg: "PPG",
        metricDeviation: "Deviation vs avg",
        state: "Data state",
        ingest: "Refresh from Vaastav",
        seasonsInDb: "GW rows in DB",
        totalPlayers: "Unique player keys",
        poolBuildTitle: "Build your Pool",
        poolBuildHint: "Search current FPL players, or paste a comma/newline separated list. Add up to 100 candidates — analysis runs at exactly 30 players (£200.0m budget).",
        poolBudget: "Budget",
        poolRemaining: "Remaining",
        poolCount: "Players",
        poolAvgPrice: "Avg price",
        poolInvalid: "Pool exceeds the £200m budget",
        poolValid: "Pool is budget-valid",
        pasteList: "Paste list",
        pasteHint: "One player per line — surname or full name.",
        importPaste: "Import",
        clearPool: "Clear",
        analyzePool: "Analyze pool",
        optimizePool: "Optimise to £200m",
        poolDnaTitle: "Team Season DNA",
        poolReport: "Recommendation report",
        phaseStrength: "Phase strength",
        topStart: "Top for start GW1-6",
        topWinter: "Top for winter GW13-24",
        topRunIn: "Top for run-in GW31-38",
        topSeasonHolders: "Top season-long holders",
        risks: "Risks",
        playerCards: "Player cards",
        typology: "Pool typology",
        typo_early_season_heavy: "Early-season heavy",
        typo_run_in_heavy: "Run-in heavy",
        typo_premium_heavy: "Premium-heavy",
        typo_value_balanced: "Value-balanced",
        typo_boom_bust: "Boom / bust",
        typo_consistency_first: "Consistency-first",
        typo_captaincy_strong: "Captaincy strong",
        typo_captaincy_weak: "Captaincy weak",
        typo_all_phase: "All-phase strong",
    },
    cs: {
        pageTitle: "FPL Timing Analyzer",
        pageSubtitle: "Historická výkonnost hráčů, konzistence a timing napříč posledními 6 sezónami Premier League (2020-21 → 2025-26).",
        loading: "Načítám…",
        noData: "Zatím žádná data — zkus upravit filtry.",
        tabExplorer: "Průzkumník hráčů",
        tabCompare: "Porovnání",
        tabFinders: "Vyhledávače",
        tabPool: "Team Season DNA",
        tabMatrix: "Fixture Matice",
        tabSimulator: "Simulátor sezóny",
        tabTransfers: "Přestupy",
        tabHauls: "Hauly",
        tabFdrPerf: "Výkon dle FDR",
        findersFdrAbility: "Dle síly soupeře",
        fdrAbilityExplain: "PPG proti soupeřům dané obtížnosti (FDR z aktuální síly týmu; celá historie 2016–2026). Delta ukazuje o kolik líp/hůř oproti celkovému průměru hráče.",
        allPositions: "Všechny pozice",
        position: "Pozice",
        seasons: "Sezóny",
        season: "Sezóna",
        totalPoints: "Celkem bodů",
        gamesPlayed: "Odehráno",
        consistency: "Konzistence",
        explosiveness: "Výbušnost",
        value: "Hodnota",
        avg: "Průměr",
        ppg: "PPG",
        gw: "GW",
        consistencyExplain: "Odměna za vysoký floor + malou rozptýlenost — kombinuje PPG a variabilitu.",
        explosivenessExplain: "% odehraných GW s ≥10 body.",
        valueExplain: "Celkové body ÷ průměrná cena (£m).",
        valueNewExplain: "Body z minulé sezóny ÷ NOVÁ cena 2026/27 — kdo dává nejvíc bodů za £m při dnešní ceně.",
        searchPlaceholder: "Hledej hráče — Salah, Haaland, Palmer…",
        pickPlayer: "Vyber hráče k prozkoumání",
        pointsCurve: "Body podle gameweeku",
        selectedSeason: "Vybraná sezóna",
        averageCurve: "Průměr 5 sezón",
        timingBreakdown: "Rozklad fáze sezóny",
        periodGw1_6: "Start (GW1-6)",
        periodGw7_12: "První třetina (GW7-12)",
        periodGw13_18: "Před Vánoci (GW13-18)",
        periodGw19_24: "Vánoce (GW19-24)",
        periodGw25_30: "Před finišem (GW25-30)",
        periodGw31_38: "Run-in (GW31-38)",
        compareIntro: "Vyber 2-4 hráče a porovnej jejich sezónní profily.",
        addPlayer: "Přidat hráče",
        remove: "Odebrat",
        findersConsistent: "Nejkonzistentnější",
        findersExplosive: "Nejvýbušnější",
        findersValue: "Nejlepší hodnota",
        findersValueNew: "Value 26/27",
        findersPeriod: "Nejlepší dle fáze sezóny",
        period: "Fáze",
        topN: "Top N",
        minSeasons: "Min sezón",
        sortStrongest: "Nejsilnější",
        sortWeakest: "Nejslabší",
        metricPpg: "PPG",
        metricDeviation: "Odchylka od průměru",
        state: "Stav dat",
        ingest: "Aktualizovat z Vaastav",
        seasonsInDb: "GW řádků v DB",
        totalPlayers: "Unikátní hráči",
        poolBuildTitle: "Sestav svůj Pool",
        poolBuildHint: "Vyhledej aktuální FPL hráče nebo vlož seznam (jméno na řádek). Můžeš mít až 100 kandidátů — analýza se spustí přesně na 30 hráčů (rozpočet £200.0m).",
        poolBudget: "Rozpočet",
        poolRemaining: "Zbývá",
        poolCount: "Hráčů",
        poolAvgPrice: "Ø cena",
        poolInvalid: "Pool překračuje limit £200m",
        poolValid: "Pool je rozpočtově validní",
        pasteList: "Vložit seznam",
        pasteHint: "Jeden hráč na řádek — příjmení nebo celé jméno.",
        importPaste: "Importovat",
        clearPool: "Vyprázdnit",
        analyzePool: "Analyzovat pool",
        optimizePool: "Optimalizovat do £200m",
        poolDnaTitle: "Team Season DNA",
        poolReport: "Doporučovací report",
        phaseStrength: "Síla fáze",
        topStart: "Nejlepší na start GW1-6",
        topWinter: "Nejlepší na Vánoce GW13-24",
        topRunIn: "Nejlepší na run-in GW31-38",
        topSeasonHolders: "Nejlepší celosezonní držáci",
        risks: "Rizika",
        playerCards: "Karty hráčů",
        typology: "Typ poolu",
        typo_early_season_heavy: "Zaměřený na start sezony",
        typo_run_in_heavy: "Silný run-in",
        typo_premium_heavy: "Premium-heavy",
        typo_value_balanced: "Value-balanced",
        typo_boom_bust: "Boom / bust",
        typo_consistency_first: "Konzistence především",
        typo_captaincy_strong: "Silné kapitánské volby",
        typo_captaincy_weak: "Slabší kapitánská hloubka",
        typo_all_phase: "Silný napříč všemi fázemi",
    },
};

export function t(key, lang = "en") {
    return STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
}

export const POSITIONS = ["GKP", "DEF", "MID", "FWD"];

export const PERIODS = [
    { key: "gw1_6",   labelKey: "periodGw1_6",   gw: [1, 6] },
    { key: "gw7_12",  labelKey: "periodGw7_12",  gw: [7, 12] },
    { key: "gw13_18", labelKey: "periodGw13_18", gw: [13, 18] },
    { key: "gw19_24", labelKey: "periodGw19_24", gw: [19, 24] },
    { key: "gw25_30", labelKey: "periodGw25_30", gw: [25, 30] },
    { key: "gw31_38", labelKey: "periodGw31_38", gw: [31, 38] },
];
